
import User from "../../../assets/duotone/User.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UserIcon({ className, dataTestid = "UserIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <User data-testid={dataTestid} className={classes} {...rest} />
  );
}
